(function () {
  "use strict";

  var COMMENTS_API =
    "https://teddy-baldassarre.vercel.app/api/article-comments";

  var THUMB_SVG = '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="12" viewBox="0 0 1200 1200" fill="currentColor">' +
    '<path d="M717.534,60.514c42.51-0.457,82.729,43.455,110.594,74.778 c65.435,80.402,29.326,169.5,14.94,267.032h298.455c40.347,0.301,61.029,30.64,58.225,71.631l-83.567,517.806 c-18.937,66.216-92.545,124.507-170.138,132.786H393.96c-32.659-0.426-57.13-23.607-59.691-59.691v-602.84 c0.424-32.654,23.607-57.13,59.691-59.689h137.251L666.999,97.939C674.551,81.511,694.346,60.885,717.534,60.514L717.534,60.514z M217.89,390.388c22.971,0.293,41.284,16.175,43.21,41.819v665.534c-0.333,22.479-18.962,39.989-43.21,41.748H43.286 c-22.155-0.304-41.2-17.095-43.286-41.748V432.208c0.316-23.22,17.976-40.06,43.286-41.819L217.89,390.388L217.89,390.388z"/>' +
    '</svg>';

  var SPINNER_SVG = '<div class="loading-overlay__spinner">' +
    '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
    '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
    '</svg></div>';

  function getAuthorParts(author) {
    var nameParts = (author || "").split(" ");
    var initials =
      (nameParts[0] || "").charAt(0) + (nameParts[1] || "").charAt(0);
    var displayName =
      (nameParts[0] || "") +
      (nameParts[1] ? " " + nameParts[1].charAt(0) + "." : "");
    return { initials: initials, displayName: displayName };
  }

  function escapeHtml(str) {
    return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  function buildLikeButton(dataset) {
    return '<button class="comments__like comments__action"' +
      (dataset.commentId ? ' data-comment-id="' + dataset.commentId + '"' : "") +
      (dataset.replyId ? ' data-reply-id="' + dataset.replyId + '"' : "") +
      ' data-email="' + dataset.email + '"' +
      ' data-article-id="' + dataset.articleId + '"' +
      ' data-customer-id="' + dataset.customerId + '">' +
      '<div class="comments__thumb-icon">' + THUMB_SVG + '</div>' +
      '<div class="comments__loading-icon">' + SPINNER_SVG + '</div>' +
      '</button>' +
      '<span class="comments__like-count"></span>';
  }

  function buildReplyForm(dataset) {
    return '<form class="replies__form"' +
      ' data-author="' + dataset.author + '"' +
      ' data-email="' + dataset.email + '"' +
      ' data-article-id="' + dataset.articleId + '"' +
      ' data-customer-id="' + dataset.customerId + '"' +
      ' data-blog-id="' + dataset.blogId + '"' +
      ' data-reply-id="' + dataset.commentId + '">' +
      '<div class="comments__body"><div class="comments__fields">' +
      '<div class="field field--with-error">' +
      '<textarea required rows="5" name="comment[body]" class="textarea" aria-required="true" placeholder="Leave a Reply"></textarea>' +
      '</div></div></div>' +
      '<div class="comments__submit">' +
      '<button type="submit" class="button button--primary button--full-width-mobile">Post Reply</button>' +
      '</div></form>';
  }

  document.addEventListener("click", function (e) {
    var button = e.target.closest("button");
    if (!button || !button.matches(".comments__reply")) return;

    e.preventDefault();

    var commentItem = button.closest(".comments__item");
    if (!commentItem) return;

    var replyForm = commentItem.querySelector(".replies__form");
    if (!replyForm) return;

    var isActive = replyForm.classList.toggle("replies__form--active");

    if (isActive) {
      replyForm.style.setProperty("display", "block", "important");
      setTimeout(function () {
        replyForm.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }, 50);
    } else {
      replyForm.style.setProperty("display", "none", "important");
    }
  }, true);

  function init() {
    var commentForm = document.querySelector(".comments__form");
    if (commentForm) {
      commentForm.addEventListener("submit", async function (e) {
        e.preventDefault();
        if (commentForm._submitting) return;
        commentForm._submitting = true;
        var form = e.target;
        var email = form.dataset.email;
        var author = form.dataset.author;
        var articleId = form.dataset.articleId;
        var customerId = form.dataset.customerId;
        var blogId = form.dataset.blogId;
        var textarea = form.querySelector("textarea");
        var body = textarea.value;
        var submit = form.querySelector("button");

        submit.setAttribute("disabled", "disabled");
        submit.innerText = "Posting...";

        try {
          var resp = await fetch(COMMENTS_API, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              action: "comment",
              email: email,
              author: author,
              articleId: articleId,
              customerId: customerId,
              blogId: blogId,
              body: body,
            }),
          });
          var result = await resp.json();

          if (result.success) {
            var parts = getAuthorParts(author);
            var commentId = result.commentId;

            var commentHtml =
              '<div class="comments__item">' +
                '<div class="comments__container">' +
                  '<div class="comments__avatar">' +
                    '<span class="comments__avatar-circle">' + parts.initials + '</span>' +
                  '</div>' +
                  '<div class="comments__body">' +
                    '<div class="comments__body-header">' +
                      '<span class="comments__body-author">' + parts.displayName + '</span>' +
                      '<span class="comments__body-date text-gray-500">Just now</span>' +
                    '</div>' +
                    '<div id="' + commentId + '" class="comments__body-body">' +
                      escapeHtml(body) +
                    '</div>' +
                    '<div class="comments__actions">' +
                      '<button type="button" class="comments__reply comments__action" data-customer-id="' + customerId + '">Reply</button>' +
                      '<div class="comments__like-cont">' +
                        buildLikeButton({ commentId: commentId, email: email, articleId: articleId, customerId: customerId }) +
                      '</div>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
                '<div class="comments__replies">' +
                  buildReplyForm({ author: author, email: email, articleId: articleId, customerId: customerId, blogId: blogId, commentId: commentId }) +
                '</div>' +
              '</div>';

            var commentsList = document.querySelector(".article-template__comments");
            if (!commentsList) {
              commentsList = document.createElement("div");
              commentsList.className = "article-template__comments";
              form.insertAdjacentElement("afterend", commentsList);
            }
            commentsList.insertAdjacentHTML("beforeend", commentHtml);

            var heading = document.querySelector(".comments__heading");
            if (heading) {
              var currentCount = parseInt(heading.textContent) || 0;
              var newCount = currentCount + 1;
              heading.textContent = newCount + " " + (newCount === 1 ? "Comment" : "Comments");
            }

            textarea.value = "";
            submit.innerText = "Post Comment";
            submit.removeAttribute("disabled");
          } else {
            submit.innerText = "Post Comment";
            submit.removeAttribute("disabled");
          }
        } catch (err) {
          console.error("Comment submission failed:", err);
          submit.innerText = "Post Comment";
          submit.removeAttribute("disabled");
        } finally {
          commentForm._submitting = false;
        }
      });
    }

    document.addEventListener("submit", async function (e) {
      var form = e.target.closest(".replies__form");
      if (!form) return;
      e.preventDefault();
      if (form._submitting) return;
      form._submitting = true;

      var email = form.dataset.email;
      var author = form.dataset.author;
      var articleId = form.dataset.articleId;
      var customerId = form.dataset.customerId;
      var replyId = form.dataset.replyId;
      var blogId = form.dataset.blogId;
      var body = form.querySelector("textarea").value;
      var submit = form.querySelector("button");

      submit.setAttribute("disabled", "disabled");
      submit.innerText = "Posting...";

      try {
        var resp = await fetch(COMMENTS_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: "reply",
            email: email,
            author: author,
            articleId: articleId,
            customerId: customerId,
            replyId: replyId,
            blogId: blogId,
            body: body,
          }),
        });
        var result = await resp.json();

        if (result.success) {
          var parts = getAuthorParts(author);

          var replyHtml =
            '<div class="comments__item">' +
              '<div class="comments__container">' +
                '<div class="comments__avatar">' +
                  '<span class="comments__avatar-circle">' + parts.initials + '</span>' +
                '</div>' +
                '<div class="comments__body">' +
                  '<div class="comments__body-header">' +
                    '<span class="comments__body-author">' + parts.displayName + '</span>' +
                    '<span class="comments__body-date text-gray-500">Just now</span>' +
                  '</div>' +
                  '<div class="comments__body-body">' +
                    escapeHtml(body) +
                  '</div>' +
                  '<div class="comments__like-cont">' +
                    buildLikeButton({ email: email, articleId: articleId, customerId: customerId }) +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>';

          var repliesContainer = form.closest(".comments__replies");
          if (repliesContainer) {
            repliesContainer.insertAdjacentHTML("beforeend", replyHtml);
          }

          form.reset();
          form.classList.remove("replies__form--active");
          form.style.setProperty("display", "none", "important");
          submit.innerText = "Post Reply";
          submit.removeAttribute("disabled");
        } else {
          submit.innerText = "Post Reply";
          submit.removeAttribute("disabled");
        }
      } catch (err) {
        console.error("Reply submission failed:", err);
        submit.innerText = "Post Reply";
        submit.removeAttribute("disabled");
      } finally {
        form._submitting = false;
      }
    });

    document.addEventListener("click", function (e) {
      var button = e.target.closest("button");

      if (button && button.matches(".comments__like")) {
        e.preventDefault();
        var thumb = button.querySelector(".comments__thumb-icon");
        var loading = button.querySelector(".comments__loading-icon");
        var text = button.parentNode.querySelector(".comments__like-count");
        var isUnlike = button.classList.contains("comments__liked");
        var data = {
          email: button.dataset.email,
          articleId: button.dataset.articleId,
          commentId: button.dataset.commentId,
          customerId: button.dataset.customerId,
          replyId: button.dataset.replyId,
          isUnlike: isUnlike,
        };

        thumb.style.display = "none";
        loading.style.display = "flex";

        fetch(COMMENTS_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "like", email: data.email, articleId: data.articleId, commentId: data.commentId, customerId: data.customerId, replyId: data.replyId, isUnlike: data.isUnlike }),
        })
          .then(function (resp) { return resp.json(); })
          .then(function (result) {
            if (result.success) {
              thumb.style.display = "block";
              loading.style.display = "none";
              var currentCount = parseInt(text.innerText);
              var likeCount = text.childNodes.length
                ? isUnlike
                  ? currentCount - 1
                  : currentCount + 1
                : 1;
              text.innerHTML =
                likeCount === 1
                  ? "1 Like"
                  : likeCount === 0
                  ? ""
                  : likeCount + " Likes";
              if (isUnlike) {
                button.classList.remove("comments__liked");
              } else {
                button.classList.add("comments__liked");
              }
            }
          })
          .catch(function (err) {
            console.warn("Something went wrong.", err);
          });
      }
    });

    document.querySelectorAll('a[href="#comments"]').forEach(function (link) {
      link.addEventListener("click", function (e) {
        var target = document.getElementById("comments");
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth" });
          history.replaceState(null, "", "#comments");
        }
      });
    });

    if (window.location.hash === "#comments") {
      var commentsEl = document.getElementById("comments");
      if (commentsEl) {
        setTimeout(function () {
          commentsEl.scrollIntoView({ behavior: "smooth" });
        }, 300);
      }
    }

    var collectionAd = document.querySelector(".article__sidebar-coll-cont");
    if (collectionAd) {
      window.addEventListener("scroll", function () {
        if (window.scrollY > 7500) {
          collectionAd.classList.remove("active");
        } else {
          collectionAd.classList.add("active");
        }
      });
    }

    var ytButton = document.querySelector(".lty-playbtn");
    if (ytButton) {
      ytButton.click();
    }

    document.addEventListener("click", function (e) {
      var button = e.target.closest("button");
      var articleHeader = document.querySelector(".article__header");
      var iframe = articleHeader ? articleHeader.querySelector("iframe") : null;
      if (button && button.matches(".article__video-trigger") && iframe) {
        articleHeader.classList.add("expanded");
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*"
        );
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
